export function unificarClienteEvents(context) {
    function csrfToken($modal) {
        var meta = document.querySelector('meta[name="csrf-token"]');
        if (meta && meta.getAttribute("content")) {
            return meta.getAttribute("content");
        }

        return $modal.data("csrf") || "";
    }

    function toastDanger(message) {
        showToastDanger($("body"), message);
    }

    function labelCliente(item) {
        if (item.pj) {
            return item.nome_fantasia || item.razao_social || item.nome || "";
        }

        return item.nome || item.nome_fantasia || item.razao_social || "";
    }

    function infoCliente(item) {
        var partes = [];
        if (item.id) {
            partes.push("#" + item.id);
        }
        if (item.email) {
            partes.push(item.email);
        }
        if (item.telefone1) {
            partes.push(item.telefone1);
        }
        if (item.cnpj) {
            partes.push(item.cnpj);
        }

        return partes.join(" · ");
    }

    function atualizarConfirmacao() {
        var destinoId = $("#unificar-destino-id").val();
        var ciente = $("#unificar-ciente").is(":checked");
        $("#unificar-confirm").prop("disabled", !(destinoId && ciente));
    }

    function resetModal() {
        $("#unificar-search").val("");
        $("#unificar-destino-id").val("");
        $("#unificar-ciente").prop("checked", false);
        $("#unificar-results").html(
            '<div class="text-muted">Digite para buscar o cliente de destino...</div>'
        );
        atualizarConfirmacao();
    }

    function renderResultados(items) {
        var $container = $("#unificar-results");
        if (!items.length) {
            $container.html('<div class="text-muted">Nenhum resultado</div>');
            return;
        }

        var $lista = $('<div class="list-group"></div>');
        items.forEach(function (item) {
            var $row = $(
                '<a href="#" class="list-group-item list-group-item-action unificar-row"></a>'
            );
            $row.attr("data-id", item.id);
            $row.append($("<strong></strong>").text(labelCliente(item)));
            $row.append("<br>");
            $row.append($('<small class="text-muted"></small>').text(infoCliente(item)));
            $lista.append($row);
        });
        $container.empty().append($lista);
    }

    $(context).on("click", ".js-unificar-cliente", function () {
        var $btn = $(this);
        $("#unificar-origem-id").val($btn.data("origem-id"));
        $(".js-unificar-origem-id").text($btn.data("origem-id"));
        $(".js-unificar-origem-nome").text($btn.data("origem-nome") || "");
        resetModal();
        $("#modalUnificarCliente").modal("show");
    });

    $(context).on("input", "#unificar-search", function () {
        var q = $(this).val().trim();
        var origemId = $("#unificar-origem-id").val();

        clearTimeout(window._unificarTimeout);
        window._unificarTimeout = setTimeout(function () {
            if (!q) {
                $("#unificar-results").html(
                    '<div class="text-muted">Digite para buscar o cliente de destino...</div>'
                );
                return;
            }

            $.ajax({
                url: siteUrl("/painel/clientes/search"),
                method: "GET",
                data: { q: q, unificar: 1, exceto_id: origemId },
                headers: { Accept: "application/json" },
            })
                .done(function (resp) {
                    var items = Array.isArray(resp) ? resp : [];
                    renderResultados(items);
                })
                .fail(function () {
                    $("#unificar-results").html(
                        '<div class="text-danger">Erro na busca</div>'
                    );
                });
        }, 300);
    });

    $(context).on("click", ".unificar-row", function (e) {
        e.preventDefault();
        var $row = $(this);
        if ($row.hasClass("active")) {
            $row.removeClass("active");
            $("#unificar-destino-id").val("");
        } else {
            $(".unificar-row.active").removeClass("active");
            $row.addClass("active");
            $("#unificar-destino-id").val($row.data("id"));
        }
        atualizarConfirmacao();
    });

    $(context).on("change", "#unificar-ciente", atualizarConfirmacao);

    $(context).on("click", "#unificar-confirm", function () {
        var $modal = $("#modalUnificarCliente");
        var origemId = $("#unificar-origem-id").val();
        var destinoId = $("#unificar-destino-id").val();
        var $btn = $(this);

        if (!origemId || !destinoId) {
            toastDanger("Selecione o cliente que receberá os dados.");
            return;
        }

        if (!$("#unificar-ciente").is(":checked")) {
            toastDanger("Confirme que está ciente de que a ação é irreversível.");
            return;
        }

        $btn.prop("disabled", true);

        $.ajax({
            url: siteUrl("/painel/clientes/" + origemId + "/unificar"),
            method: "POST",
            data: { destino_id: destinoId },
            headers: {
                "X-CSRF-TOKEN": csrfToken($modal),
                Accept: "application/json",
            },
        })
            .done(function (resp) {
                if (resp && resp.success && resp.redirect) {
                    window.location = resp.redirect;
                    return;
                }
                toastDanger((resp && resp.message) || "Erro ao unificar");
                atualizarConfirmacao();
            })
            .fail(function (xhr) {
                var message =
                    (xhr.responseJSON && xhr.responseJSON.message) ||
                    "Não foi possível unificar o cliente.";
                toastDanger(message);
                atualizarConfirmacao();
            });
    });
}
